// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"f1eab35b","341":"1764c211","372":"5d64ef59","588":"c75a162a","661":"4f0d39aa","728":"feadda07","961":"a84e844a","970":"b2e3a1ca"}[chunkId] + ".chunk.js";
};